import React from 'react';

const Policy = () => {
    const sections = [
        { id: 'primero', title: 'PRIMERO. OBJETIVO' },
        { id: 'segundo', title: 'SEGUNDO. ALCANCE' },
        { id: 'tercero', title: 'TERCERO. OBLIGACIONES' },
        { id: 'cuarto', title: 'CUARTO. OBLIGACIONES (ESPECÍFICAS)' },
        { id: 'quinto', title: 'QUINTO. RESPONSABLE DEL TRATAMIENTO' },
        { id: 'sexto', title: 'SEXTO. TRATAMIENTO Y FINALIDAD' },
        { id: 'septimo', title: 'SÉPTIMO. GLOSARIO' },
        { id: 'octavo', title: 'OCTAVO. DERECHOS DE LOS TITULARES' },
        { id: 'noveno', title: 'NOVENO. FUNDAMENTO LEGAL' },
        { id: 'decimo', title: 'DÉCIMO. PRINCIPIOS' },
        { id: 'decimoprimero', title: 'DÉCIMO PRIMERO. DATOS SENSIBLES Y NIÑOS' },
        { id: 'decimosegundo', title: 'DÉCIMO SEGUNDO. MEDIO DE ALMACENAMIENTO' },
        { id: 'decimotercero', title: 'DÉCIMO TERCERO. DURACIÓN' },
        { id: 'decimocuarto', title: 'DÉCIMO CUARTO. ELIMINACIÓN DE LOS DATOS' },
        { id: 'decimoquinto', title: 'DÉCIMO QUINTO. MEDIDAS DE SEGURIDAD' },
        { id: 'decimosexto', title: 'DÉCIMO SEXTO. MEDIDAS DE PROTECCIÓN' },
        { id: 'decimoseptimo', title: 'DÉCIMO SÉPTIMO. GESTIÓN DE INCIDENTES' },
        { id: 'decimooctavo', title: 'DÉCIMO OCTAVO. DEBERES DE ENCARGADOS' },
        { id: 'decimonoveno', title: 'DÉCIMO NOVENO. ATENCIÓN DE PETICIONES' },
        { id: 'vigesimo', title: 'VIGÉSIMO. SIN AUTORIZACIÓN' },
        { id: 'vigesimoprimero', title: 'VIGÉSIMO PRIMERO AL VIGÉSIMO TERCERO. PROCEDIMIENTOS' },
        { id: 'vigesimocuarto', title: 'VIGÉSIMO CUARTO. CAMBIOS' },
        { id: 'vigesimoquinto', title: 'VIGÉSIMO QUINTO. VIGENCIA' },
    ];

    const scrollToSection = (e, id) => {
        e.preventDefault();
        const element = document.getElementById(id);
        if (element) {
            const offset = 120; // Matches sticky header height
            const bodyRect = document.body.getBoundingClientRect().top;
            const elementRect = element.getBoundingClientRect().top;
            const elementPosition = elementRect - bodyRect;
            const offsetPosition = elementPosition - offset;

            window.scrollTo({
                top: offsetPosition,
                behavior: 'smooth'
            });
        }
    };

    return (
        <div className="fullPadding bgColor2" style={{ minHeight: '100vh', paddingTop: '100px' }}>
            {/* Fixed Back Button */}
            <a
                href="#/"
                className="btn2"
                style={{
                    position: 'fixed',
                    top: '20px',
                    left: '20px',
                    zIndex: 1000,
                    padding: '10px 20px',
                    color: 'white',
                    textDecoration: 'none',
                    boxShadow: '0 4px 10px rgba(0,0,0,0.2)'
                }}
            >
                ← Volver al inicio
            </a>

            <style>
                {`
                    html {
                        scroll-behavior: smooth;
                    }
                    .policy-container {
                        display: flex;
                        gap: 40px;
                        max-width: 1200px;
                        margin: 0 auto;
                        padding: 0 20px;
                    }
                    .policy-sidebar {
                        width: 300px;
                        position: sticky;
                        top: 100px;
                        height: fit-content;
                        max-height: calc(100vh - 120px);
                        overflow-y: auto;
                        padding: 20px;
                        background: white;
                        border-radius: 10px;
                        border: 1px solid rgba(0, 0, 0, 0.1);
                        box-shadow: 0 4px 6px rgba(0, 0, 0, 0.05);
                    }
                    .policy-sidebar h3 {
                        font-size: 16px;
                        margin-bottom: 15px;
                        color: var(--color1);
                        border-bottom: 2px solid var(--color4);
                        padding-bottom: 8px;
                    }
                    .policy-sidebar ul {
                        list-style: none;
                        padding: 0;
                        margin: 0;
                    }
                    .policy-sidebar li {
                        margin-bottom: 10px;
                    }
                    .policy-sidebar a {
                        font-size: 13px;
                        text-decoration: none;
                        transition: color 0.2s;
                        cursor: pointer;
                    }
                    .policy-sidebar a:hover {
                        color: var(--color4);
                    }
                    .policy-content {
                        flex: 1;
                        background: white;
                        border-radius: 10px;
                        border: 1px solid rgba(0, 0, 0, 0.1);
                        padding: 40px;
                        box-shadow: 0 4px 6px rgba(0, 0, 0, 0.05);
                        line-height: 1.6;
                        text-align: left;
                    }
                    @media (max-width: 992px) {
                        .policy-container {
                            flex-direction: column;
                        }
                        .policy-sidebar {
                            width: 100%;
                            position: relative;
                            top: 0;
                            max-height: 300px;
                            margin-bottom: 20px;
                        }
                    }
                    @media (max-width: 600px) {
                        .policy-content {
                            padding: 20px;
                        }
                    }
                `}
            </style>

            <div className="policy-container">
                {/* Fixed Sidebar for Navigation */}
                <aside className="policy-sidebar">
                    <h3>Índice</h3>
                    <ul>
                        {sections.map(section => (
                            <li key={section.id}>
                                <a
                                    href={`#${section.id}`}
                                    onClick={(e) => scrollToSection(e, section.id)}
                                >
                                    {section.title}
                                </a>
                            </li>
                        ))}
                    </ul>
                </aside>

                {/* Main Content Area */}
                <main className="policy-content">
                    <h1 className="color1" style={{ fontSize: '28px', marginBottom: '20px', textAlign: 'center', fontWeight: '800' }}>
                        POLÍTICA PARA EL TRATAMIENTO DE DATOS PERSONALES
                    </h1>

                    <p style={{ textAlign: 'center', fontWeight: 'bold', fontSize: '18px', color: '#555', marginBottom: '40px' }}>
                        GUIAR ARQUITECTURA E INFRAESTRUCTURA S.A.S.
                    </p>

                    <section id="primero">
                        <h2 className="color4" style={{ fontSize: '20px', marginTop: '30px', borderLeft: '4px solid var(--color4)', paddingLeft: '15px' }}>PRIMERO. OBJETIVO</h2>
                        <p>GUIAR ARQUITECTURA E INFRAESTRUCTURA S.A.S. como organización legalmente constituida, y con el fin de cumplir con lo establecido por la norma, elaboró la presente Política para el Tratamiento y Protección de Datos Personales, cuyo fin es brindar a los interesados, especialmente a aquellos a quienes recopila, manipula, y conserva sus datos personales.</p>
                        <p>Con este documento GUIAR ARQUITECTURA E INFRAESTRUCTURA S.A.S. busca garantizar la protección efectiva de los datos personales durante todo el proceso de tratamiento, desde su recolección, almacenamiento en bases de datos, registro, uso o divulgación, así mismo establecer el procedimiento por el cual el interesado puede solicitar a la empresa el acceso, inclusión, exclusión, corrección, adición, actualización y certificación de sus datos, igualmente la limitación en las posibilidades de divulgación, publicación o cesión de los mismos, de conformidad con los principios que regulan el proceso de administración de datos personales, en respeto de los derechos que se indican en la Ley 1581 de 2012 específicamente en los artículos 15 y 20.</p>
                    </section>

                    <section id="segundo">
                        <h2 className="color4" style={{ fontSize: '20px', marginTop: '30px', borderLeft: '4px solid var(--color4)', paddingLeft: '15px' }}>SEGUNDO. ALCANCE</h2>
                        <p>Esta política aplica para toda la información personal registrada en las bases de datos de la empresa GUIAR ARQUITECTURA E INFRAESTRUCTURA S.A.S. quien actúa en calidad de responsable del tratamiento de datos personales.</p>
                    </section>

                    <section id="tercero">
                        <h2 className="color4" style={{ fontSize: '20px', marginTop: '30px', borderLeft: '4px solid var(--color4)', paddingLeft: '15px' }}>TERCERO. OBLIGACIONES</h2>
                        <p>Esta política es de obligatorio cumplimiento para la empresa GUIAR ARQUITECTURA E INFRAESTRUCTURA S.A.S.</p>
                    </section>

                    <section id="cuarto">
                        <h2 className="color4" style={{ fontSize: '20px', marginTop: '30px', borderLeft: '4px solid var(--color4)', paddingLeft: '15px' }}>CUARTO. OBLIGACIONES (ESPECÍFICAS)</h2>
                        <p>Para el Tratamiento de los datos personales sensibles, GUIAR ARQUITECTURA E INFRAESTRUCTURA S.A.S. cumplirá las siguientes obligaciones:</p>
                        <ul style={{ paddingLeft: '20px' }}>
                            <li>a. Informar al Titular de forma explícita y previa, cuáles de los datos que serán objeto de Tratamiento.</li>
                            <li>b. Informar cuáles son sensibles y la finalidad del Tratamiento, así como obtener su consentimiento expreso.</li>
                            <li>c. Informar al Titular que, por tratarse de datos personales sensibles, no está obligado a autorizar su tratamiento.</li>
                            <li>d. El suministro de los datos personales de los niños, niñas y adolescentes debe realizarse con autorización de los padres de familia o representantes legales del menor.</li>
                        </ul>
                    </section>

                    <section id="quinto">
                        <h2 className="color4" style={{ fontSize: '20px', marginTop: '30px', borderLeft: '4px solid var(--color4)', paddingLeft: '15px' }}>QUINTO. RESPONSABLE DEL TRATAMIENTO</h2>
                        <p>La empresa GUIAR ARQUITECTURA E INFRAESTRUCTURA S.A.S. sociedad comercial legalmente constituida, identificada con el NIT 901300696, con domicilio principal en la ciudad de Medellín, Antioquia Colombia en la dirección transversal 35 # 72 – 81 Apt 101, es la responsable del tratamiento de los datos personales.</p>
                    </section>

                    <section id="sexto">
                        <h2 className="color4" style={{ fontSize: '20px', marginTop: '30px', borderLeft: '4px solid var(--color4)', paddingLeft: '15px' }}>SEXTO. TRATAMIENTO Y FINALIDAD</h2>
                        <p>La recolección, almacenamiento, uso, circulation y tratamiento de los datos personales que realizará la empresa GUIAR ARQUITECTURA E INFRAESTRUCTURA S.A.S. con la información personal tendrá las siguientes finalidades:</p>

                        <h3 className="color4" style={{ fontSize: '18px', marginTop: '20px', fontWeight: '700' }}>a. Generales</h3>
                        <p>Desarrollar el objeto social de la empresa relativas a la construcción, diseño, reparación y obras de arquitectura. Cumplir obligaciones legales, contractuales, contables, administrativas, judiciales y tributarias. Garantizar la seguridad de la información, de los clientes, trabajadores, proveedores y de las instalaciones.</p>

                        <h3 className="color4" style={{ fontSize: '18px', marginTop: '20px', fontWeight: '700' }}>b. Clientes</h3>
                        <p>Atender solicitudes de información, enviar cotizaciones, elaborar propuestas y celebrar contratos de diseño, reparación o construcción. Ejecutar y hacer seguimiento a los proyectos contratados por clientes, facturar y gestionar pagos y cobros, atender peticiones, quejas y reclamos. Enviar comunicaciones sobre los servicios contratados e información comercial cuando exista autorización.</p>

                        <h3 className="color4" style={{ fontSize: '18px', marginTop: '20px', fontWeight: '700' }}>c. Proveedores y contratistas</h3>
                        <p>Estudiar, seleccionar y vincular proveedores y contratistas. Verificar requisitos legales, técnicos y de seguridad. Ejecutar contratos comerciales de suministro o prestación de servicios, gestionar pagos, cobros y obligaciones contables, y controlar el acceso a obras y oficinas.</p>

                        <h3 className="color4" style={{ fontSize: '18px', marginTop: '20px', fontWeight: '700' }}>d. Empleados y candidatos</h3>
                        <p>Adelantar procesos de selección y contratación, llevar a cabo procesos durante la relación laboral, cumplir obligaciones en materia de control y manejo de riesgos laborales, gestionar nómina, prestaciones sociales, liquidaciones, préstamos y descuentos. Garantizar la seguridad y salud en el trabajo y prevenir acoso laboral.</p>

                        <h3 className="color4" style={{ fontSize: '18px', marginTop: '20px', fontWeight: '700' }}>e. Seguridad</h3>
                        <p>Controlar el ingreso y permanencia en oficinas y obras, garantizar la seguridad de personas, equipos e instalaciones y registrar novedades o incidentes ocurridos en obras.</p>

                        <h3 className="color4" style={{ fontSize: '18px', marginTop: '20px', fontWeight: '700' }}>f. Registros de obra</h3>
                        <p>Realizar registros fotográficos y audiovisuales de los proyectos para fines técnicos, contractuales y comerciales.</p>

                        <h3 className="color4" style={{ fontSize: '18px', marginTop: '20px', fontWeight: '700' }}>g. Gestión interna de la organización</h3>
                        <p>Desarrollar los procesos de control disciplinario, gestionar los procesos de divulgación de información con medios de comunicación, desarrollar procesos estadísticos y de análisis para la mejora en los procesos de toma de decisión y la medición de indicadores.</p>
                        <p>Mejorar el funcionamiento de servicios, cumplir requisitos legales y de la seguridad en los servicios tales como sitios web o servicio online, herramientas tecnológicas, de inteligencia artificial, electrónicas, páginas web, sistemas de información, aplicaciones web, app´s, software de GUIAR ARQUITECTURA E INFRAESTRUCTURA S.A.S.</p>
                        <p>El sitio web <a href="https://guiararquitectura.com.co" target="_blank" rel="noopener noreferrer" style={{ fontWeight: 'bold' }}>https://guiararquitectura.com.co</a> recoge información estándar de registro. Para asegurar que este Sitio Web está siendo bien administrado, la empresa o proveedores de servicios hacen uso de cookies o web beacons.</p>

                        <h3 className="color4" style={{ fontSize: '18px', marginTop: '20px', fontWeight: '700' }}>h. Transmisión de datos</h3>
                        <p>Compartir datos personales con terceros que apoyen la operación de la empresa tales como contadores, ARL, EPS, aseguradoras y proveedores tecnológicos, únicamente para cumplir las finalidades descritas y conforme a la ley.</p>
                    </section>

                    <section id="septimo">
                        <h2 className="color4" style={{ fontSize: '20px', marginTop: '30px', borderLeft: '4px solid var(--color4)', paddingLeft: '15px' }}>SÉPTIMO. GLOSARIO</h2>
                        <ul style={{ paddingLeft: '20px', lineHeight: '1.8' }}>
                            <li><strong>Archivo:</strong> Conjunto de documentos acumulados en un proceso natural por una persona u organización.</li>
                            <li><strong>Autorización:</strong> Consentimiento previo, expreso e informado del Titular para el Tratamiento.</li>
                            <li><strong>Aviso de privacidad:</strong> Comunicación dirigida al Titular para el tratamiento de sus datos.</li>
                            <li><strong>Base de Datos:</strong> Conjunto organizado de datos personales objeto de Tratamiento.</li>
                            <li><strong>Dato personal:</strong> Cualquier información vinculada a personas naturales.</li>
                            <li><strong>Dato privado:</strong> Dato que sólo es relevante para el titular.</li>
                            <li><strong>Dato público:</strong> Dato calificado como tal según la ley.</li>
                            <li><strong>Dato semiprivado:</strong> Dato cuyo conocimiento puede interesar a cierto sector.</li>
                            <li><strong>Datos sensibles:</strong> Aquellos que afectan la intimidad o pueden generar discriminación.</li>
                            <li><strong>Encargado del Tratamiento:</strong> Persona que realice el Tratamiento por cuenta del responsable.</li>
                            <li><strong>Responsable del Tratamiento:</strong> Persona que decida sobre la base de datos y/o el Tratamiento.</li>
                            <li><strong>Titular:</strong> Persona natural cuyos datos personales sean objeto de Tratamiento.</li>
                            <li><strong>Tratamiento:</strong> Cualquier operación sobre datos personales.</li>
                        </ul>
                    </section>

                    <section id="octavo">
                        <h2 className="color4" style={{ fontSize: '20px', marginTop: '30px', borderLeft: '4px solid var(--color4)', paddingLeft: '15px' }}>OCTAVO. DERECHOS DE LOS TITULARES</h2>
                        <ul style={{ paddingLeft: '20px', lineHeight: '1.8' }}>
                            <li>Derecho a revocar la autorización y/o solicitar la supresión del dato.</li>
                            <li>Derecho a conocer, actualizar y rectificar los datos personales.</li>
                            <li>Derecho a solicitar prueba de la autorización otorgada.</li>
                            <li>Derecho a solicitar información respecto del uso que la organización le ha dado a sus datos.</li>
                            <li>Derecho a presentar quejas ante la Superintendencia de Industria y Comercio.</li>
                            <li>Derecho a acceder en forma gratuita a sus datos personales.</li>
                        </ul>
                    </section>

                    <section id="noveno">
                        <h2 className="color4" style={{ fontSize: '20px', marginTop: '30px', borderLeft: '4px solid var(--color4)', paddingLeft: '15px' }}>NOVENO. FUNDAMENTO LEGAL</h2>
                        <p>Constitución Política de Colombia (Art. 15), Ley 1581 de 2012, Decreto 1074 de 2015, Ley 1266 de 2008, Ley 1273 de 2009, entre otras.</p>
                    </section>

                    <section id="decimo">
                        <h2 className="color4" style={{ fontSize: '20px', marginTop: '30px', borderLeft: '4px solid var(--color4)', paddingLeft: '15px' }}>DÉCIMO. PRINCIPIOS</h2>
                        <p>Legalidad, Finalidad, Libertad, Veracidad, Transparencia, Acceso y circulación restringida, Seguridad y Confidencialidad.</p>
                    </section>

                    <section id="decimoprimero">
                        <h2 className="color4" style={{ fontSize: '20px', marginTop: '30px', borderLeft: '4px solid var(--color4)', paddingLeft: '15px' }}>DÉCIMO PRIMERO. DATOS SENSIBLES Y NIÑOS</h2>
                        <p>El tratamiento está prohibido, salvo excepciones legales, siempre respetando el interés superior de los menores y sus derechos fundamentales, con autorización del representante legal.</p>
                    </section>

                    <section id="decimosegundo">
                        <h2 className="color4" style={{ fontSize: '20px', marginTop: '30px', borderLeft: '4px solid var(--color4)', paddingLeft: '15px' }}>DÉCIMO SEGUNDO. MEDIO DE ALMACENAMIENTO</h2>
                        <p>Físico y Digital (Excel y Google Drive).</p>
                    </section>

                    <section id="decimotercero">
                        <h2 className="color4" style={{ fontSize: '20px', marginTop: '30px', borderLeft: '4px solid var(--color4)', paddingLeft: '15px' }}>DÉCIMO TERCERO. DURACIÓN</h2>
                        <p>Vigencia correspondiente con la finalidad para el cual se autorizó su tratamiento y de las normas especiales.</p>
                    </section>

                    <section id="decimocuarto">
                        <h2 className="color4" style={{ fontSize: '20px', marginTop: '30px', borderLeft: '4px solid var(--color4)', paddingLeft: '15px' }}>DÉCIMO CUARTO. ELIMINACIÓN DE LOS DATOS</h2>
                        <p>Cumplidos los términos, los datos serán eliminados de forma segura (trituración, borrado permanente), salvo obligación legal de conservación.</p>
                    </section>

                    <section id="decimoquinto">
                        <h2 className="color4" style={{ fontSize: '20px', marginTop: '30px', borderLeft: '4px solid var(--color4)', paddingLeft: '15px' }}>DÉCIMO QUINTO. MEDIDAS DE SEGURIDAD</h2>
                        <p>Adopción de medidas técnicas, humanas y administrativas. Acceso restringido al personal autorizado (Gestión Humana, Administración) bajo obligaciones de confidencialidad.</p>
                    </section>

                    <section id="decimosexto">
                        <h2 className="color4" style={{ fontSize: '20px', marginTop: '30px', borderLeft: '4px solid var(--color4)', paddingLeft: '15px' }}>DÉCIMO SEXTO. MEDIDAS DE PROTECCIÓN</h2>
                        <p>Usuarios y contraseñas, antivirus, copias de seguridad, acuerdos de confidencialidad y control de acceso limitado.</p>
                    </section>

                    <section id="decimoseptimo">
                        <h2 className="color4" style={{ fontSize: '20px', marginTop: '30px', borderLeft: '4px solid var(--color4)', paddingLeft: '15px' }}>DÉCIMO SÉPTIMO. GESTIÓN DE INCIDENTES</h2>
                        <p>Reporte inmediato, análisis, adopción de medidas correctivas y notificación a la SIC y titulares si aplica.</p>
                    </section>

                    <section id="decimooctavo">
                        <h2 className="color4" style={{ fontSize: '20px', marginTop: '30px', borderLeft: '4px solid var(--color4)', paddingLeft: '15px' }}>DÉCIMO OCTAVO. DEBERES DE ENCARGADOS</h2>
                        <p>Cumplimiento del artículo 18 de la Ley 1581 de 2012.</p>
                    </section>

                    <section id="decimonoveno">
                        <h2 className="color4" style={{ fontSize: '20px', marginTop: '30px', borderLeft: '4px solid var(--color4)', paddingLeft: '15px' }}>DÉCIMO NOVENO. ATENCIÓN DE PETICIONES</h2>
                        <div style={{ background: '#f9f9f9', padding: '20px', borderRadius: '8px', marginTop: '10px' }}>
                            <p><strong>Virtual:</strong> <a href="mailto:administrativo@guiararquitectura.com">administrativo@guiararquitectura.com</a></p>
                            <p><strong>Telefónica:</strong> 304 443 74 63</p>
                            <p><strong>Presencial:</strong> Transversal 35 # 72 – 81 Apt 101, Medellín.</p>
                            <p><strong>Horario:</strong> Lunes a viernes de 7:30 am hasta las 5:00 pm</p>
                        </div>
                    </section>

                    <section id="vigesimo">
                        <h2 className="color4" style={{ fontSize: '20px', marginTop: '30px', borderLeft: '4px solid var(--color4)', paddingLeft: '15px' }}>VIGÉSIMO. SIN AUTORIZACIÓN</h2>
                        <p>Casos excepcionales: información requerida por entidad pública, datos públicos, urgencia médica, fines estadísticos o Registro Civil.</p>
                    </section>

                    <section id="vigesimoprimero">
                        <h2 className="color4" style={{ fontSize: '20px', marginTop: '30px', borderLeft: '4px solid var(--color4)', paddingLeft: '15px' }}>VIGÉSIMO PRIMERO AL VIGÉSIMO TERCERO. PROCEDIMIENTOS</h2>
                        <p>El titular o personas autorizadas pueden realizar consultas (respuesta en 10 días hábiles) o reclamos de actualización, rectificación, supresión o revocatoria (respuesta en 15 días hábiles) a través de los canales mencionados.</p>
                    </section>

                    <section id="vigesimocuarto">
                        <h2 className="color4" style={{ fontSize: '20px', marginTop: '30px', borderLeft: '4px solid var(--color4)', paddingLeft: '15px' }}>VIGÉSIMO CUARTO. CAMBIOS</h2>
                        <p>Cualquier cambio sustancial será comunicado a través del sitio web or correo electrónico.</p>
                    </section>

                    <section id="vigesimoquinto">
                        <h2 className="color4" style={{ fontSize: '20px', marginTop: '30px', borderLeft: '4px solid var(--color4)', paddingLeft: '15px' }}>VIGÉSIMO QUINTO. VIGENCIA</h2>
                        <p style={{ fontWeight: 'bold' }}>Aprobada por la representante legal GLORIA ELENA SANIN. Entra en vigencia el día 1 de febrero de 2026.</p>
                    </section>

                    <div style={{ marginTop: '50px', borderTop: '1px solid #ddd', paddingTop: '20px', textAlign: 'center' }}>
                        <a href="#/" className="btn2" style={{ display: 'inline-block', textDecoration: 'none', padding: '10px 20px' }}>
                            Volver al inicio
                        </a>
                    </div>
                </main>
            </div>
        </div>
    );
};

export default Policy;
